/// <amd-module name="Wit/LinkedWorkItemsDropdown/Components/LinkedWorkItemsCreateBranch" />
import * as React from "react";
import { Components } from "VSS/Platform/Layout";
import { ArtifactCompleteListener, ArtifactLinkNames, getBranchArtifactLink } from "../Util/Artifact";
import { ILinkedWorkItemsDropdownProps, LinkedWorkItemsDropdown } from "./LinkedWorkItemsDropdown";

interface GitRepository {
    id: string;
    project: { id: string };
}

export interface ICreateBranchContext {
    addBranchCreateListener: (listener: BranchCreateListener) => void;
}

export declare type BranchCreateListener = (repository: GitRepository, branchName: string) => void | Promise<void>;

export interface ILinkedWorkItemsCreateBranchProps {
    createBranchContext: ICreateBranchContext;
    initialWorkItemIds?: number[];
}

export class LinkedWorkItemsCreateBranch extends React.Component<ILinkedWorkItemsCreateBranchProps> {
    private artifactListener: ArtifactCompleteListener | undefined;

    public render(): JSX.Element {
        const linkedWorkItemsProps: ILinkedWorkItemsDropdownProps = {
            artifactChangesContext: {
                addArtifactCompleteListener: (listener: ArtifactCompleteListener): void => {
                    this.artifactListener = listener;
                    this.props.createBranchContext.addBranchCreateListener(this.linkWorkItems);
                }
            },
            initialWorkItems: this.props.initialWorkItemIds
        };

        return <LinkedWorkItemsDropdown {...linkedWorkItemsProps} />;
    }

    private linkWorkItems = (repository: GitRepository, branchName: string): Promise<void> | void => {
        if (this.artifactListener) {
            const projectGuid = repository.project.id;
            const repositoryId = repository.id;

            const artifactLinks = [getBranchArtifactLink(projectGuid, repositoryId, branchName, ArtifactLinkNames.BranchToWorkItem)];

            return this.artifactListener(artifactLinks);
        }
    };
}

Components.add("WIT.LinkedWorkItemsCreateBranch", LinkedWorkItemsCreateBranch);
